export default __webpack_public_path__ + "static/media/safeReveal.6b5a7a2c.jpg";